var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('el-button',{staticClass:"bacToIndex",attrs:{"size":"mini"},on:{"click":_vm.backtoIndex}},[_vm._v("返回首页")]),_c('div',{staticClass:"topTitle"},[_vm._v("园区企业")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }